export interface Ride {
    orderId?: number | null;
    orderStatus?: OrderStatus | null;
    stops?: IStop[] | null;
    rideStartPinCode?: string | null;
    country?: string | null;
    division?: IDivision | null;
    driver?: IDriver | null;
    routeDetails?: IRouteDetails | null;
    changeHistory?: IChangeHistory | null;
    type?: RideType | null;
    company?: ICompany | null;
    canceledBy?: CanceledBy | null;
    isMeetAndGreet?: boolean;
    pickupInstructions?: string;
    isShareRide?: boolean;
}
interface IDivision {
    name?: string | null;
    picture?: string | null;
    type?: DivisionType | null;
}

enum DivisionType {
    DIVISION_TYPE_TRANSPORTATION = 0,
    DIVISION_TYPE_DELIVERY = 1,
}

interface IRouteDetails {
    isUntrackble?: boolean | null;
    driverLocation?: ICoordinates | null;
    eta?: IETA | null;
    distance?: number | null;
    polyline?: string | null;
    bearing?: number | null;
}

export interface IETA {
    range?: IETARange | null;
    minutesLeft?: number | null;
}
export interface IETARange {
    from?: ITimestamp | null;
    to?: ITimestamp | null;
}

export interface IStop {
    location?: ILocation | null;
    type?: LocationType | null;
    actions?: IStopAction[] | null;
}

export enum LocationType {
    LOCATION_TYPE_ORIGIN = 0,
    LOCATION_TYPE_DESTINATION = 1,
    LOCATION_TYPE_ONGOING = 2,
}

interface IStopAction {
    type?: StopActionType | null;
    parcel?: IParcel | null;
}

export interface IParcel {
    name?: string | null;
    note?: string | null;
}

export enum StopActionType {
    STOP_ACTION_PICKUP = 0,
    STOP_ACTION_DROP_OFF = 1,
    STOP_ACTION_STOP_BY = 2,
}

export interface IChangeHistory {
    scheduledAt?: ITimestamp | null;
    completedAt?: ITimestamp | null;
}
interface ITimestamp {
    seconds?: number | null;
    nanos?: number | null;
}

export enum OrderStatus {
    ORDER_STATUS_UNSPECIFIED = 0,
    ORDER_STATUS_ROUTING = 1,
    ORDER_STATUS_PENDING = 2,
    ORDER_STATUS_CONFIRMED = 3,
    ORDER_STATUS_CANCELLED = 4,
    ORDER_STATUS_WAITING = 5,
    ORDER_STATUS_DRIVING = 6,
    ORDER_STATUS_COMPLETED = 7,
    ORDER_STATUS_CARE_REQUESTED = 8,
    ORDER_STATUS_REJECTED = 9,
    ORDER_STATUS_ASSIGNED = 10,
    ORDER_STATUS_RESERVED = 11,
    ORDER_STATUS_UNRESERVED = 12,
    ORDER_STATUS_NOT_FOUND = 22,
}

export const FinalStatuses = [
    OrderStatus.ORDER_STATUS_CANCELLED,
    OrderStatus.ORDER_STATUS_COMPLETED,
    OrderStatus.ORDER_STATUS_REJECTED,
] as const;

interface IDriver {
    id?: number | null;
    name?: string | null;
    phoneNumber?: string | null;
    photoUrl?: string | null;
    rating?: number | null;
    ratingCount?: number | null;
    car?: ICar | null;
    fleetName?: string | null;
}

interface ICar {
    number?: string | null;
    type?: string | null;
    model?: string | null;
    color?: string | null;
}

export interface ILocation {
    coordinates?: ICoordinates | null;
    address?: string | null;
    note?: string | null;
}

export interface ICoordinates {
    latitude?: number | null;
    longitude?: number | null;
}

export const NOT_FOUND_ERR = 'tracking not found';

export enum RideType {
    RIDE_TYPE_RIDER = 0,
    RIDE_TYPE_SENDER = 1,
    RIDE_TYPE_RECIPIENT = 2,
    RIDE_TYPE_SENDER_AND_RECIPIENT = 3,
}

export interface ICompany {
    name?: string | null;
    logo?: string | null;
}

export enum CanceledBy {
    CANCELED_BY_UNSPECIFIED = 0,
    CANCELED_BY_DRIVER = 1,
    CANCELED_BY_CC = 2,
    CANCELED_BY_API = 3,
    CANCELED_BY_BOOKER = 4,
    CANCELED_BY_RIDER = 5,
}
